import { render, staticRenderFns } from "./CheckRoomInputs.vue?vue&type=template&id=52331f02&lang=pug&"
import script from "./CheckRoomInputs.vue?vue&type=script&lang=ts&"
export * from "./CheckRoomInputs.vue?vue&type=script&lang=ts&"
import style0 from "./CheckRoomInputs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports